<div class="marginBottom-xl">
  <vy-flight-summary
    [flightJourneyDataOutbound]="flightSummaryData!.flightJourneyDataOutbound"
    [flightJourneyDataReturn]="flightSummaryData!.flightJourneyDataReturn"
    [flightDetailsDataOutbound]="flightSummaryData!.flightDetailsDataOutbound"
    [flightDetailsDataReturn]="flightSummaryData!.flightDetailsDataReturn"
    [hasConnectionOutbound]="flightSummaryData!.hasConnectionOutbound"
    [hasConnectionReturn]="flightSummaryData!.hasConnectionReturn"
    [routeTitleOutbound]="flightSummaryData!.routeTitleOutbound"
    [routeTitleReturn]="flightSummaryData!.routeTitleReturn"
    (clickedInboundFlight)="openFlightsInfoSidePanel(1)"
    (clickedOutboundFlight)="openFlightsInfoSidePanel(0)"
  >
  </vy-flight-summary>
</div>
